import { motion } from "framer-motion";
import { IMAGES } from "../../data/content";

export const Hero = () => (
  <section id="top" className="relative overflow-hidden bg-white pt-28 md:pt-36 pb-16 md:pb-24">
    <div className="absolute -top-40 -right-40 w-[560px] h-[560px] rounded-full bg-brand/10 blur-3xl pointer-events-none" />
    <div className="max-w-7xl mx-auto px-5 md:px-8 grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
      >
        <h1 className="font-heading font-black text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05] text-zinc-900">
          Singurul card <span className="text-brand">cu adevărat</span> pentru elevi și studenți
        </h1>
        <p className="mt-6 text-base md:text-lg text-zinc-600 leading-relaxed max-w-xl">
          Cardul tău BRD-ISIC este mai mult decât un card bancar. Include legitimația
          internațională ISIC, singura legitimație de elev sau student recunoscută la nivel global,
          susținută de UNESCO și prezentă în peste 130 de țări. Astfel, ai acces la reduceri
          și beneficii în România și în străinătate, de la food, shopping și travel până la
          transport, tech, cultură și multe altele.
        </p>
        <div className="mt-8 flex flex-wrap items-center gap-4">
          <a
            href="#beneficii"
            data-testid="hero-cta-benefits"
            className="inline-flex items-center rounded-full bg-brand px-8 py-3.5 text-base font-semibold text-white shadow-lg shadow-brand/25 hover:bg-brand-dark hover:-translate-y-0.5 transition-[background-color,transform] duration-300"
          >
            Vezi beneficiile
          </a>
        </div>
      </motion.div>
      <motion.div
        initial={{ opacity: 0, y: 32 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, delay: 0.15, ease: "easeOut" }}
        className="relative"
      >
        <img
          src={IMAGES.card}
          alt="Cardul BRD-ISIC"
          data-testid="hero-card-image"
          className="w-full max-w-lg mx-auto rounded-3xl shadow-2xl shadow-brand/20 ring-1 ring-zinc-200"
        />
      </motion.div>
    </div>
  </section>
);
